/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type ChainFixKind = typeof ChainFixKind[keyof typeof ChainFixKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChainFixKind = {
  BorderOutbound: 'BorderOutbound',
  BorderInbound: 'BorderInbound',
  Link: 'Link',
} as const;
